import { doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { db } from "../../firebase";

const EditIUITreatments = ({
  id,
  iuiSheets,
  one,
  two,
  three,
  four,
  five,
  six,
  seven,
  eight,
  nine,
  ten,
  eleven,
  twelve,
  thirteen,
  fourteen,
  fifteen,
  sixteen,
}) => {
  const [createISheet, setCreateISheet] = useState(iuiSheets);
  const [createOne, setCreateOne] = useState(one);
  const [createTwo, setCreateTwo] = useState(two);
  const [createThree, setCreateThree] = useState(three);
  const [createFour, setCreateFour] = useState(four);
  const [createFive, setCreateFive] = useState(five);
  const [createSix, setCreateSix] = useState(six);
  const [createSeven, setCreateSeven] = useState(seven);
  const [createEight, setCreateEight] = useState(eight);
  const [createNine, setCreateNine] = useState(nine);
  const [createTen, setCreateTen] = useState(ten);
  const [createEleven, setCreateEleven] = useState(eleven);
  const [createTwelve, setCreateTwelve] = useState(twelve);
  const [createThirteen, setCreateThirteen] = useState(thirteen);
  const [createFourteen, setCreateFourteen] = useState(fourteen);
  const [createFifteen, setCreateFifteen] = useState(fifteen);
  const [createSixteen, setCreateSixteen] = useState(sixteen);

  const { userId } = useParams();

  const updateData = async (e) => {
    e.preventDefault();
    try {
      const taskDocument = doc(db, "greenleaf/" + userId, "iuiTreatments", id);
      await updateDoc(taskDocument, {
        iuiSheets: createISheet,
        one: createOne,
        two: createTwo,
        three: createThree,
        four: createFour,
        five: createFive,
        six: createSix,
        seven: createSeven,
        eight: createEight,
        nine: createNine,
        ten: createTen,
        eleven: createEleven,
        twelve: createTwelve,
        thirteen: createThirteen,
        fourteen: createFourteen,
        fifteen: createFifteen,
        sixteen: createSixteen,
      });
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {/* Modal Button */}
      <button
        type="button"
        className="btn btn-primary btn-sm"
        data-bs-toggle="modal"
        data-bs-target={`#id${id}`}
      >
        <EditNoteIcon />
      </button>

      <div
        className="modal fade"
        id={`id${id}`}
        tabIndex="-1"
        aria-labelledby="editLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id="editLabel"
                style={{ color: "grey" }}
              >
                Update IUI Treatment Sheet
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div class="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="enter IUI Headers"
                    defaultValue={createISheet}
                    onChange={(e) => setCreateISheet(e.target.value)}
                    size="3080"
                  />
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="pair-1">
                      IUI Listing
                    </span>
                  </div>
                </div>

                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="pair-2">
                      One vis IUI Row Data and Two vis IUI Row Data
                    </span>
                  </div>
                  <input
                    type="text"
                    placeholder="counting from one vis IUI Row Data"
                    className="form-control"
                    defaultValue={createOne}
                    onChange={(e) => setCreateOne(e.target.value)}
                    size="3080"
                  />
                  <input
                    type="text"
                    placeholder="counting from two vis IUI Row Data"
                    className="form-control"
                    defaultValue={createTwo}
                    onChange={(e) => setCreateTwo(e.target.value)}
                    size="3080"
                  />
                </div>

                <div class="input-group">
                  <input
                    type="text"
                    placeholder="counting from three vis IUI Row Data"
                    className="form-control"
                    defaultValue={createThree}
                    onChange={(e) => setCreateThree(e.target.value)}
                    size="3080"
                  />
                  <input
                    type="text"
                    placeholder="counting from four vis IUI Row Data"
                    className="form-control"
                    defaultValue={createFour}
                    onChange={(e) => setCreateFour(e.target.value)}
                    size="3080"
                  />
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="pair-3">
                      Three vis IUI Row Data and Four vis IUI Row Data
                    </span>
                  </div>
                </div>

                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="pair-4">
                      Five vis IUI Row Data and Six vis IUI Row Data
                    </span>
                  </div>
                  <input
                    type="text"
                    placeholder="counting from five vis IUI Row Data"
                    className="form-control"
                    defaultValue={createFive}
                    onChange={(e) => setCreateFive(e.target.value)}
                    size="3080"
                  />
                  <input
                    type="text"
                    placeholder="counting from six vis IUI Row Data"
                    className="form-control"
                    defaultValue={createSix}
                    onChange={(e) => setCreateSix(e.target.value)}
                    size="3080"
                  />
                </div>

                <div class="input-group">
                  <input
                    type="text"
                    placeholder="counting from seven vis IUI Row Data"
                    className="form-control"
                    defaultValue={createSeven}
                    onChange={(e) => setCreateSeven(e.target.value)}
                    size="3080"
                  />
                  <input
                    type="text"
                    placeholder="counting from eight vis IUI Row Data"
                    className="form-control"
                    defaultValue={createEight}
                    onChange={(e) => setCreateEight(e.target.value)}
                    size="3080"
                  />
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="pair-5">
                      Seven vis IUI Row Data and Eight vis IUI Row Data
                    </span>
                  </div>
                </div>

                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="pair-6">
                      Nine vis IUI Row Data and Ten vis IUI Row Data
                    </span>
                  </div>
                  <input
                    type="text"
                    placeholder="counting from nine vis IUI Row Data"
                    className="form-control"
                    defaultValue={createNine}
                    onChange={(e) => setCreateNine(e.target.value)}
                    size="3080"
                  />
                  <input
                    type="text"
                    placeholder="counting from ten vis IUI Row Data"
                    className="form-control"
                    defaultValue={createTen}
                    onChange={(e) => setCreateTen(e.target.value)}
                    size="3080"
                  />
                </div>

                <div class="input-group">
                  <input
                    type="text"
                    placeholder="counting from eleven vis IUI Row Data"
                    className="form-control"
                    defaultValue={createEleven}
                    onChange={(e) => setCreateEleven(e.target.value)}
                    size="3080"
                  />
                  <input
                    type="text"
                    placeholder="counting from twelve vis IUI Row Data"
                    className="form-control"
                    defaultValue={createTwelve}
                    onChange={(e) => setCreateTwelve(e.target.value)}
                    size="3080"
                  />
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="pair-7">
                      Eleven vis IUI Row Data and Twelve vis IUI Row Data
                    </span>
                  </div>
                </div>

                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="pair-8">
                      Thirteen vis IUI Row Data and Fourteen vis IUI Row Data
                    </span>
                  </div>
                  <input
                    type="text"
                    placeholder="counting from thirteen vis IUI Row Data"
                    className="form-control"
                    defaultValue={createThirteen}
                    onChange={(e) => setCreateThirteen(e.target.value)}
                    size="3080"
                  />
                  <input
                    type="text"
                    placeholder="counting from fourteen vis IUI Row Data"
                    className="form-control"
                    defaultValue={createFourteen}
                    onChange={(e) => setCreateFourteen(e.target.value)}
                    size="3080"
                  />
                </div>

                <div class="input-group">
                  <input
                    type="text"
                    placeholder="counting from fifteen vis IUI Row Data"
                    className="form-control"
                    defaultValue={createFifteen}
                    onChange={(e) => setCreateFifteen(e.target.value)}
                    size="3080"
                  />
                  <input
                    type="text"
                    placeholder="counting from sixteen vis IUI Row Data"
                    className="form-control"
                    defaultValue={createSixteen}
                    onChange={(e) => setCreateSixteen(e.target.value)}
                    size="3080"
                  />
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="pair-9">
                      Fifteen vis IUI Row Data and Sixteen vis IUI Row Data
                    </span>
                  </div>
                </div>
              </form>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => updateData(e)}
              >
                Update Sheet
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditIUITreatments;
